const customFooterClass = "footer";
const EditorClasses = {
  Editor: "t-editor",
  Anchor: "t-editor__anchor",
  Bold: "t-editor__bold",
  Button: "t-editor__button",
  Callout: "t-editor__callout",
  Card: "t-editor__card",
  Code: "t-editor__code",
  CodeContainer: "t-editor__code-container",
  CodeGroup: "t-editor__code-group",
  CodeMirror: "t-editor__codemirror",
  Column: "t-editor__column",
  Detail: "t-editor__detail",
  Embed: "t-editor__embed",
  File: "t-editor__file",
  FinePrint: "t-editor__fine-print",
  Grid: "t-editor__grid",
  Group: "t-editor__group",
  Heading: "t-editor__heading",
  Highlight: "t-editor__highlight",
  Icon: "t-editor__icon",
  IconError: "t-editor__detail-icon--error",
  Image: "t-editor__image",
  InlineCode: "t-editor__inline-code",
  Italic: "t-editor__italic",
  LineBreak: "t-editor__line-break",
  PageLink: "t-editor__page-link",
  List: "t-editor__list",
  LanguagePicker: "t-editor__language-picker",
  CheckList: "t-editor__checklist",
  Mark: "t-editor__mark",
  Math: "t-editor__math",
  PageTitle: "t-editor__page-title",
  Paragraph: "t-editor__paragraph",
  Quote: "t-editor__quote",
  Row: "t-editor__row",
  Strike: "t-editor__strike",
  Tabs: "t-editor__tabs",
  Table: "t-editor__table",
  Underline: "t-editor__underline",
  Step: "t-editor__step",
  Steps: "t-editor__steps",
  Subscript: "t-editor__subscript",
  Superscript: "t-editor__superscript"
};
export {
  EditorClasses,
  customFooterClass
};
//# sourceMappingURL=styles.js.map
